module.exports = __webpack_public_path__ + "img/06.cc0f9137.jpg";